
export class Acknowledgement {       
    parentDocumentVersion !: number;
    parentDocumentNumber !: string;
    status!: string;
    assignedInternalUser!: string;
    dueDate?:Date;
    acknowledgementDate?:Date;
    isDeleted = false;
}
